import styled from 'styled-components'

export const StyledReviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
`
export const StyledReviewerInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`
export const StyledReviews = styled.div`
  margin-top: 0.1rem;
  min-width: 3rem;
`
